import React, { useState } from "react";

import { Trash2 as BinIcon } from "react-feather";

import {
  Grid,
  GridProps,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";

import { default as BaseModal } from "@ds-developer/modal";
import Button from "@ds-developer/button";

import { DeleteTimeOffConfirmationModalProps } from "./types";

const useStyles = makeStyles(theme => ({
  shiftedButtonWrapper: {
    [theme.breakpoints.up("sm")]: {
      marginLeft: "auto",
    },
  },
}));

const DeleteTimeOffConfirmationModal: React.FC<DeleteTimeOffConfirmationModalProps> = ({
  onCancel = () => {},
  onClick = () => {},
  repeat,
  submitting,
  loading = false,
}) => {
  const theme = useTheme();
  const classes = useStyles();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const [selection, setSelection] = useState<"ONE" | "ALL">();

  const handleClick = (option: "ONE" | "ALL") => {
    setSelection(option);
    onClick(option);
  };

  /* The mobile/desktop layouts are different enough that this seemed like the
     simplest way to style them. Open to other suggestions! */
  const containerProps: GridProps = isMobile
    ? {
        direction: "column-reverse",
        alignItems: "center",
        spacing: 2,
      }
    : {
        direction: "row",
        wrap: "nowrap",
        spacing: 3,
      };

  const actions = (
    <Grid container {...containerProps}>
      <Grid item>
        <Button onClick={onCancel} disabled={submitting} variant="outlined">
          Cancel
        </Button>
      </Grid>
      <Grid item classes={{ root: classes.shiftedButtonWrapper }}>
        {repeat && (
          <Button
            onClick={() => {
              handleClick("ONE");
            }}
            disabled={submitting}
            loading={loading && selection === "ONE"}
            variant="outlined"
          >
            Just this one
          </Button>
        )}
      </Grid>
      <Grid item>
        {repeat ? (
          <Button
            color="primary"
            onClick={() => {
              handleClick("ALL");
            }}
            disabled={submitting}
            loading={loading && selection === "ALL"}
            variant="contained"
          >
            All events
          </Button>
        ) : (
          <Button
            color="error"
            onClick={() => {
              handleClick("ONE");
            }}
            disabled={submitting}
            loading={loading && selection === "ONE"}
            startIcon={<BinIcon size={16} />}
            variant="contained"
          >
            Yes, delete
          </Button>
        )}
      </Grid>
    </Grid>
  );

  return (
    <BaseModal
      open
      title={
        repeat
          ? "Would you like to delete all future repeating events?"
          : "Are you sure you want to delete this unavailable slot?"
      }
      actions={actions}
    />
  );
};

export default DeleteTimeOffConfirmationModal;
